import { FeatureFlag } from '../FeatureFlag';

export const hideAccountCreation = new FeatureFlag({
    key: 'hide-account-creation',
    defaultValue: false,
});
